import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const ChevronRight = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props} aria-hidden="true">
            <path
                id="arrow"
                d="M14.2055 11.5643L7 4.27139L8.39726 2.85718L17 11.5643L8.39726 20.2714L7 18.8572L14.2055 11.5643Z"
                fill="currentColor"
            />
        </Icon>
    )
}

ChevronRight.propTypes = {onClick: PropTypes.func}

export default ChevronRight
